import Mask from '__components/Mask';
import { EmTouchableOpacity } from 'emrn-design/EmTouchable';
import { LinearGradient } from 'emrn-design/LinearGradient';
import { Spacer } from 'emrn-design/Spacer';
import { rpx } from 'emrn-design/rpx';
import React, { Component } from 'react';
import { StyleSheet, View, Text, Image, ScrollView } from 'react-native';

interface Props {
  onPress: Function;
}

interface State {
  isShow: boolean;
  tips: string;
}
/**
 * 温馨提示 今日抽奖奖励已发放完毕 请明日10点后再来
 * */
export class TipsPop extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isShow: false,
      tips: '',
    };
  }

  show = (tips: string) => {
    this.setState({ isShow: true, tips: tips });
  };

  hide = () => {
    this.setState({ isShow: false });
  };

  render() {
    const { isShow, tips } = this.state;
    const { onPress } = this.props;
    return (
      <>
        {isShow ? (
          <Mask>
            <View style={styles.content}>
              <LinearGradient
                start={{ x: 0, y: 0 }}
                end={{ x: 0, y: 0.19 }}
                colors={['#FFF7C2', '#FFFFFF']}
                style={styles.main}
              >
                <Spacer size={rpx(24)} />
                <Image
                  style={styles.popTitleTip}
                  source={require('../../images/invite/popTitleTip.png')}
                  resizeMode={'stretch'}
                />
                <Spacer size={rpx(22)} />
                <Text style={styles.text}>{tips}</Text>
                <Spacer size={rpx(30)} />
                <EmTouchableOpacity
                  onPress={() => {
                    onPress && onPress();
                    this.hide();
                  }}
                >
                  <Image
                    style={styles.completeBtn}
                    source={require('../../images/invite/iKnow.png')}
                    resizeMode={'stretch'}
                  />
                </EmTouchableOpacity>
                <Spacer size={rpx(30)} />
              </LinearGradient>
            </View>
          </Mask>
        ) : null}
      </>
    );
  }
}

const styles = StyleSheet.create({
  content: {
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  main: {
    width: rpx(300),
    backgroundColor: '#fff',
    borderRadius: rpx(32),
    alignItems: 'center',
  },
  text: {
    width: rpx(200),
    fontSize: rpx(15),
    color: '#333333',
    lineHeight: rpx(24),
    textAlign: 'center',
  },
  popTitleTip: {
    width: rpx(94),
    height: rpx(21),
  },
  completeBtn: {
    width: rpx(210),
    height: rpx(51),
  },
});
